<template>
  <div>
    <div class="w-full flex items-center border py-2 px-2 rounded relative" :class="error ? 'border-red-700' : 'border-secondary3'" :style="type === 'textarea' ? '' : 'height: 46px'">
      <label v-if="label" :for="name" class="absolute text-xs font-medium px-1" :class="error ? 'text-red-700 '+bglabel : 'text-secondary3 '+bglabel" style="top: -0.625rem; left: 0.5rem">{{ label }}</label>
      <textarea-autosize
        v-if="type === 'textarea'"
        :value="value"
        :readonly="readonly"
        :placeholder="placeholder"
        :max-height="120"
        :min-height="height"
        class="bg-transparent border-none w-full text-sm md:text-base text-secondary3 placeholder-placeholder py-1 px-1 leading-tight focus:outline-none"
        @blur.native="onInput"
      />
      <input
        v-else-if="type === 'duration'"
        :name="name"
        :value="durationValue"
        type="text"
        maxLength="8"
        :readonly="readonly"
        :placeholder="placeholder"
        class="html-duration-picker bg-transparent border-none w-full text-secondary3 placeholder-placeholder py-1 px-1 leading-tight focus:outline-none"
        @input="onInputDuration"
      >
      <input
        v-else
        :id="name"
        :name="name"
        :min="min"
        :max="max"
        :step="step"
        :value="value"
        :type="type"
        :readonly="readonly"
        :placeholder="placeholder"
        class="bg-transparent border-none w-full text-secondary3 placeholder-placeholder py-1 px-1 leading-tight focus:outline-none"
        @input="onInput"
      >
      <div :class="'absolute px-2 '+bglabel" style="right: 0.5rem">{{ extend }}</div>
    </div>
    <div v-if="error && showError" class="mt-1 ml-3 text-red-700 text-xs" v-html="error"></div>
  </div>
</template>

<script>
export default {
  name: "CustomInput",
  props: {
    min: { type: Number, required: false, default: 0 },
    max: { type: Number, required: false, default: 99999 },
    step: { type: Number, required: false },
    type: { type: String, required: false, default: "text" },
    rows: { type: Number, required: false, default: 2 },
    value: { type: [String, Number], required: false },
    label: { type: String, required: false },
    extend: { type: String, required: false, default: "" },
    bglabel: { type: String, required: false, default: "bg-white" },
    readonly: { type: Boolean, required: false, default: false },
    showError: { type: Boolean, required: false, default: false },
    placeholder: { type: String, required: false }
  },
  computed: {
    name() {
      if (this.label) return this.label.replace(" ", "-").toLowerCase()
      else return this.value.replace(" ", "-").toLowerCase()
    },
    height() {
      return this.rows * 20
    }
  },
  data() {
    return {
      durationValue: "",
      error: null
    }
  },
  mounted() {
    if (this.type === "duration") this.durationValue = this.value
  },
  watch: {
    value: function(val) {
      this.durationValue = val
    }
  },
  methods: {
    onInput(event) {
      const data = event.target.value
      this.checkValue(data)
      this.$emit("update:value", data)
    },
    checkValue(data) {
      if (!data) {
        this.error = this.label + " should not be empty"
      } else {
        this.error = null
      }
    },
    onInputDuration(event) {
      const time = event.target.value
      this.durationValue = time
      if (time.length === 8) {
        let validation = true
        if (isNaN(parseFloat(time.charAt(0)))) validation = false
        if (isNaN(parseFloat(time.charAt(1)))) validation = false
        if (time.charAt(2) !== ":") validation = false
        if (time.charAt(3) > 5 || isNaN(parseFloat(time.charAt(3)))) validation = false
        if (isNaN(parseFloat(time.charAt(4)))) validation = false
        if (time.charAt(5) !== ":") validation = false
        if (time.charAt(6) > 5 || isNaN(parseFloat(time.charAt(6)))) validation = false
        if (isNaN(parseFloat(time.charAt(7)))) validation = false
        if (validation) {
          this.error = null
          this.$emit("update:value", time)
        } else {
          this.error = "Goal Time is not valid! (e.g 99:59:59)"
        }
      } else {
        this.error = "Goal Time is not valid! (e.g 99:59:59)"
      }
    }
  }
}
</script>

<style scoped lang="scss">/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomInput.vue